import { openUrl } from '@tauri-apps/plugin-opener';

export const CHILD_PRIVACY_URL = 'https://chorepop.com/privacy/children';

export async function openChildPrivacyInformation(
  opener: (url: string) => Promise<void> = openUrl,
): Promise<void> {
  await opener(CHILD_PRIVACY_URL);
}
